import { PublicResource } from '../../resource-types';
import { RawModel } from '../schema';
import { MetadataValueTypes } from './metadata-field-type';

export interface ContractKey extends PublicResource {
  json_schema: string;
  read_only: boolean;
  required: boolean;
  uses_suggestions: boolean;
  value_type: MetadataValueTypes;
}

export const contractKey: RawModel = {
  type: 'contract-key',
  plural: 'contract-keys',
  JSONApi: true,
  useWorker: true,
  attributes: {
    id: 'UUID',
    json_schema: 'string',
    read_only: 'boolean',
    required: 'boolean',
    uses_suggestions: 'boolean',
    value_type: 'string'
  },
  relationships: {}
};
